module.exports = __webpack_public_path__ + "img/symbol_4.df090128.png";